import React, { useEffect, useRef, useState } from 'react'
import { BsTwitter, BsInstagram, BsFacebook, BsLinkedin } from 'react-icons/bs';
import { TfiClose } from 'react-icons/tfi';
import { VscMenu } from 'react-icons/vsc'
import { Link } from 'react-router-dom'
import logo from './../../assets/logo.svg';
import { MdOutlineKeyboardArrowDown, MdOutlineKeyboardArrowUp } from 'react-icons/md';

const Navbar = () => {
    const [top, setTop] = useState(" ")
    const [navOpen, setNavOpen] = useState(false)
    const [toggleOpen, setToggleOpen] = useState(false)
    const [position, setPosition] = useState("absolute")
    const [background, setBackground] = useState("bg-main-light")
    const [opacity, setOpacity] = useState("bg-opacity-25")
    const navbarRef = useRef(null)
    useEffect(() => {
        const handleScroll = () => {
            // if (scrollY >= 2 * navbarRef.current?.clientHeight) {
            if (window.scrollY >= 110) {
                setBackground("bg-main")
                setOpacity("bg-opacity-90")
                setPosition("fixed")
                setTop("top-0")
            } else {
                setBackground("bg-main-light")
                setOpacity("bg-opacity-25")
                setTop(" ")
                setPosition("absolute")
            }
        }

        window.addEventListener("scroll", handleScroll)
        return () => window.removeEventListener("scroll", handleScroll)
    }, [])
    return (
        <nav ref={navbarRef} className={`${background} ${opacity} text-white select-none ${position} ${top} duration-300 left-0 right-0 z-50`}>
            <div className="mx-auto w-5/6 lg:w-4/6">
                <div className="relative flex h-16 items-center justify-between">
                    <div className="absolute inset-y-0 right-0 flex items-center md:hidden">
                        <button onClick={() => setNavOpen(!navOpen)} type="button" className="relative inline-flex items-center justify-center rounded-md p-2 focus:outline-none text-white" aria-controls="mobile-menu" aria-expanded="false">
                            {!navOpen ? <VscMenu size={22} /> : <TfiClose size={22} />}
                        </button>
                    </div>
                    <div className="flex flex-1 items-center justify-start md:items-stretch">
                        <div className="flex md:hidden items-center">
                            <Link to="/">
                                <img src={logo} className="h-8" alt="" />
                            </Link>
                        </div>
                        <div className="hidden md:block">
                            <div className="flex space-x-1 gap-5">
                                <Link to="/" className="hover:text-gold rounded-md py-2 text-sm font-medium font-Krub">Home</Link>
                                <Link to="/about" className="hover:text-gold rounded-md py-2 text-sm font-medium font-Krub">About</Link>
                                <div className="relative">
                                    <div>
                                        <button onClick={() => setToggleOpen(!toggleOpen)} type="button" className="hover:text-gold rounded-md py-2 text-sm font-medium font-Krub flex items-center" id="user-menu-button" aria-expanded="false" aria-haspopup="true">
                                            Pages
                                            {!toggleOpen ? <MdOutlineKeyboardArrowDown size={18} /> : <MdOutlineKeyboardArrowUp size={18} />}
                                        </button>
                                    </div>
                                    <div className={`${!toggleOpen && "hidden"}  absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none`} role="menu" aria-orientation="vertical" aria-labelledby="user-menu-button">
                                        <Link onClick={() => setToggleOpen(!toggleOpen)} to="/services" className="block px-4 py-2 text-sm text-gray-700 font-Krub hover:text-gold" role="menuitem" tabIndex="-1" id="user-menu-item-0">Services</Link>
                                        <Link onClick={() => setToggleOpen(!toggleOpen)} to="/blogs" className="block px-4 py-2 text-sm text-gray-700 font-Krub hover:text-gold" role="menuitem" tabIndex="-1" id="user-menu-item-1">Blogs</Link>
                                    </div>
                                </div>
                                <Link to="/projects" className="hover:text-gold rounded-md py-2 text-sm font-medium font-Krub">Projects</Link>
                                <Link to="/contact" className="hover:text-gold rounded-md py-2 text-sm font-medium font-Krub">Contact</Link>
                            </div>
                        </div>
                    </div>
                    <div className="hidden md:flex gap-4">
                        <div className="social-links flex items-center justify-center gap-4 text-white">
                            <a target="_blank" href="/" className="hover:text-gold">
                                <BsInstagram />
                            </a>
                            <a target="_blank" href="/" className="hover:text-gold">
                                <BsFacebook />
                            </a>
                            <a target="_blank" href="/" className="hover:text-gold">
                                <BsTwitter />
                            </a>
                            <a target="_blank" href="/" className="hover:text-gold">
                                <BsLinkedin />
                            </a>
                        </div>
                        <div className="quote bg-white py-5 border-2 border-white px-4 text-dark text-sm">
                            <button className="font-semibold ">Request Quote</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* mobile view */}
            <div className={`md:hidden ${!navOpen && 'hidden duration-300'}`} id="mobile-menu">
                <div className="space-y-1 px-5 pb-5 pt-2 justify-center bg-dark-navy ">
                    <Link onClick={() => setNavOpen(!navOpen)} to="/" className="hover:text-gold block rounded-md px-3 py-2 text-base font-medium font-Krub">Home</Link>
                    <Link onClick={() => setNavOpen(!navOpen)} to="/about" className="hover:text-gold block rounded-md px-3 py-2 text-base font-medium font-Krub">About</Link>
                    <div className="relative">
                        <div>
                            <button onClick={() => setToggleOpen(!toggleOpen)} type="button" className="hover:text-gold rounded-md px-3 py-2 text-base font-medium font-Krub flex items-center" id="user-menu-button" aria-expanded="false" aria-haspopup="true">
                                Pages
                                {!toggleOpen ? <MdOutlineKeyboardArrowDown size={18} /> : <MdOutlineKeyboardArrowUp size={18} />}
                            </button>
                        </div>
                        <div className={`${!toggleOpen && "hidden"}  absolute left-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none`} role="menu" aria-orientation="vertical" aria-labelledby="user-menu-button">
                            <Link onClick={() => { setToggleOpen(!toggleOpen); setNavOpen(!navOpen) }} to="/services" className="block px-4 py-2 text-sm text-gray-700 font-Krub hover:text-gold" role="menuitem" tabIndex="-1" id="user-menu-item-0">Services</Link>
                            <Link onClick={() => { setToggleOpen(!toggleOpen); setNavOpen(!navOpen) }} to="/blogs" className="block px-4 py-2 text-sm text-gray-700 font-Krub hover:text-gold" role="menuitem" tabIndex="-1" id="user-menu-item-1">Blogs</Link>
                        </div>
                    </div>
                    <Link onClick={() => setNavOpen(!navOpen)} to="/projects" className="hover:text-gold block rounded-md px-3 py-2 text-base font-medium font-Krub">Projects</Link>
                    <Link onClick={() => setNavOpen(!navOpen)} to="/contact" className="hover:text-gold block rounded-md px-3 py-2 text-base font-medium font-Krub">Contact</Link>
                    <div className="flex pb-2 px-3 flex-row justify-between gap-4">
                        <div className="social-links flex items-center sm:justify-center gap-3 xxs:gap-4 text-white">
                            <a target="_blank" href="/" className="hover:text-gold">
                                <BsInstagram />
                            </a>
                            <a target="_blank" href="/" className="hover:text-gold">
                                <BsFacebook />
                            </a>
                            <a target="_blank" href="/" className="hover:text-gold">
                                <BsTwitter />
                            </a>
                            <a target="_blank" href="/" className="hover:text-gold">
                                <BsLinkedin />
                            </a>
                        </div>
                        <div className="quote  ">
                            <button className="font-semibold bg-white border-2 border-white  text-dark text-xs xxs:text-sm py-2 px-3 xxs:py-3 xxs:px-6 md:py-5 md:px-11">Request Quote</button>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    )
}
export default Navbar